module.exports = __webpack_public_path__ + "img/u3dm-logo-duotone.d312d685.svg";